import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 41.95 33"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32.95 7.58c-4.96 0-9 4.02-9 8.95s4.04 8.95 9 8.95 9-4.02 9-8.95c-.03-4.93-4.04-8.95-9-8.95Zm0 13.09c-2.3 0-4.2-1.86-4.2-4.17s1.87-4.17 4.2-4.17 4.2 1.86 4.2 4.17c-.03 2.31-1.9 4.17-4.2 4.17Z",
      style: {"fill":"#99bfe1"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M23.7 23.78a10.223 10.223 0 0 1-7.1 2.86c-5.63 0-10.2-4.54-10.2-10.14S10.96 6.36 16.6 6.36c2.76 0 5.27 1.1 7.1 2.86 1.35-1.7 3.15-3.01 5.24-3.74A16.616 16.616 0 0 0 16.6 0C7.44 0 0 7.4 0 16.5S7.44 33 16.6 33c4.9 0 9.28-2.13 12.34-5.48a11.61 11.61 0 0 1-5.24-3.74Z",
      style: {"fill":"#223f5d"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "B0-logo"}) } }